<template>
    <div>
        <b-modal 
            v-model="mostrarModalHabilitarFornecedor" 
            @hidden="fecharModal()" 
            size="md" 
            no-close-on-backdrop
        >
            <div slot="modal-title">Habilitar Fornecedor</div>

            <b-row>
                <b-col>
                    <b-form-group>
                        <label for="data-base-reajustamento" class="required">Data base para reajustamento</label>
                        <date-picker
                            id="data-base-reajustamento"
                            v-model="dataBaseReajustamento"
                            :config="$datePickerOptions"
                            v-mask="'##/##/####'"
                            @input="$v.dataBaseReajustamento.$touch()"
                            :state="$v.dataBaseReajustamento.$error ? false : null"
                        />
                        <b-form-invalid-feedback v-if="!$v.dataBaseReajustamento.required && $v.dataBaseReajustamento.$dirty">
                            A Data base para reajustamento é obrigatória.
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-form-group>
                        <label for="justificativa-habilitacao">Justificativa</label>
                        <b-form-textarea
                            id="justificativa-habilitacao"
                            v-model="justificativa"
                            rows="3"
                            max-rows="6"
                            :no-resize="true"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback v-if="!$v.justificativa.required && $v.justificativa.$dirty">
                            A Justificativa deve conter no máximo 500 caracteres
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <b-form-group>
                        <label for="nota-tecnica-habilitacao" class="required">Anexar Nota Técnica</label>
                        <b-form-file
                            id="nota-tecnica-habilitacao"
                            v-model="arquivoNotaTecnica"
                            ref="selecaoArquivo"
                            placeholder="Selecione o arquivo..."
                            browse-text="Selecione o arquivo"
                            accept=".pdf"
                            @input="validarArquivoNotaTecnica"
                        ></b-form-file>
                        <b-form-invalid-feedback :state="arquivoNotaTecnica && arquivoNotaTecnicaValido">
                            O arquivo deve ter no máximo 10MB.
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

            <div slot="modal-footer">
                <b-button 
                    ref="btnCancelar"
                    class="mr-2"
                    variant="secondary" 
                    @click.stop="fecharModal()" 
                >
                    Cancelar
                </b-button>

                <b-button
                    ref="btnConfirmar"
                    variant="primary"
                    :disabled="$v.$invalid || !arquivoNotaTecnicaValido"
                    @click.stop="confirmarHabilitarFornecedor"
                >
                    Confirmar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import PropostaPrecoServico from '../PropostaPrecoServico';
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
    name: 'ModalHabilitarFornecedor',
    props: {
        mostrarModal: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            mostrarModalHabilitarFornecedor: false,
            dataBaseReajustamento: null,
            justificativa: '',
            arquivoNotaTecnica: null,
            arquivoNotaTecnicaValido: false,
        }
    },
    computed: {
    },

    validations: {
        dataBaseReajustamento: {
            required
        },
        
        justificativa: {
            maxLength: maxLength(500)
        }
    },

    methods: {
        limparForm(){
            this.dataBaseReajustamento = null;
            this.justificativa = '';
            this.arquivoNotaTecnica = null;
            this.arquivoNotaTecnicaValido = false;
            this.$v.$reset();
        },

        validarArquivoNotaTecnica(file) {
            const umMega = 1024 * 1024;
            const maxSize = 10 * umMega;
            this.arquivoNotaTecnicaValido = !!(file && file.size <= maxSize);
        },

        fecharModal() {
            this.mostrarModalHabilitarFornecedor = false;
            this.limparForm();
            this.$emit('update:mostrarModal', this.mostrarModalHabilitarFornecedor);
        },

        confirmarHabilitarFornecedor() {
            this.$swal({
                title: 'Confirmação',
                html: `Deseja realmente Habilitar o fornecedor da proposta de preço?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.isConfirmed) {
                    this.habilitarFornecedor();
                }
            })
        },

        habilitarFornecedor() {
            const dto = {
                dataBaseReajustamento: this.$moment(this.dataBaseReajustamento, 'DD/MM/YYYY').toISOString(),
                justificativa: this.justificativa,
                notaTecnica: this.arquivoNotaTecnica
            }

            this.$store.dispatch('addRequest')

            PropostaPrecoServico.HabilitarFornecedor(this.$route.params.propostaPrecoId, dto)
                .then(response => {
                    if (response.success) {
                        this.$toast.success('Fornecedor habilitado com sucesso', 'Sucesso', this.$toastConfig.success);
                        this.$toast.info('Um e-mail de notificação foi enviado ao fornecedor', 'E-mail enviado', this.$toastConfig.info)
                        this.fecharModal();
                        this.$emit('fornecedorHabilitado');
                    } else {
                        this.erros = response.errors || ['Erro ao habilitar fornecedor'];
                        this.$toast.error(
                            'Erro ao habilitar fornecedor!',
                            'Erro',
                            this.$toastConfig.error
                        );
                    }
                })
                .catch(error => {
                    console.error('Erro ao habilitar fornecedor:', error);
                    this.erros = [`Erro ao habilitar fornecedor: ${error}`];
                    this.$toast.error(
                        'Erro ao habilitar fornecedor!',
                        'Erro',
                        this.$toastConfig.error
                    );
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                });
        },

    },

    watch: {
        mostrarModal(newVal) {
            this.mostrarModalHabilitarFornecedor = newVal;
        },
    }
}
</script>